import React from "react";
import { Card, CardBody, Row, Col, Label, Button } from "reactstrap";
import { VendorDownloadSvg } from "../../../components/CommonSvg";
import { fileKind, fileSize } from "./documentUtils";

const initials = (name) =>
    String(name || "")
        .trim()
        .split(/\s+/)
        .map((word) => word[0])
        .slice(0, 2)
        .join("")
        .toUpperCase();

const DocumentDetailsModal = ({ document, onDownload, extraRows }) => {
    if (!document) {
        return null;
    }

    const kind = fileKind(document.documentName);
    const uploaderName = document.owner || "You";

    return (
        <div className="doc-view">
            <Card className="doc-view-file">
                <CardBody>
                    <div className="doc-view-file-row">
                        <span className={`doc-type-tag ${kind.cls}`}>
                            {kind.label}
                        </span>
                        <div className="doc-view-fcol">
                            <div
                                className="doc-view-fname"
                                title={document.documentName}
                            >
                                {document.documentName || document.documentTitle}
                            </div>
                            <div className="doc-view-fmeta">
                                {kind.type}
                                {document.fileSize
                                    ? ` · ${fileSize(document.fileSize)}`
                                    : ""}
                            </div>
                        </div>
                        {onDownload && (
                            <Button
                                color="primary"
                                className="doc-view-dlbtn"
                                onClick={() => onDownload(document)}
                            >
                                <VendorDownloadSvg size={16} />
                            </Button>
                        )}
                    </div>
                </CardBody>
            </Card>

            <div className="doc-view-block">
                <Label className="doc-view-klabel">Title</Label>
                <div className="doc-view-title">{document.documentTitle || "—"}</div>
            </div>

            <div className="doc-view-block">
                <Label className="doc-view-klabel">Remark</Label>
                <div className="doc-view-quote">{document.remarks || "No remark added"}</div>
            </div>

            {extraRows}

            <Row className="doc-view-block g-3">
                <Col xs="6">
                    <Label className="doc-view-klabel">Uploaded By</Label>
                    <div className="doc-view-person">
                        <span className="doc-view-avatar">
                            {initials(uploaderName)}
                        </span>
                        {uploaderName}
                    </div>
                </Col>
                <Col xs="6">
                    <Label className="doc-view-klabel">Uploaded At</Label>
                    <div className="doc-view-value">{document.createdDate || "—"}</div>
                </Col>
            </Row>
        </div>
    );
};

export default DocumentDetailsModal;
